import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Typography, Button, Fade } from '@mui/material';
import sendBroadcast from '../../../utils/sendBroadcast';
import { selectDuplicateReason } from '../../../state/singleInstance/singleInstanceSlice';

const handleRefresh = () => window.location.reload();

const POLL_INTERVAL_MS = 3000;

const APP_NAME = 'Comet Web Application';

const COPY = {
  'on-call': {
    title: `${APP_NAME} is already opened and on a call elsewhere`,
    body: `To start using ${APP_NAME} here, close the existing browser window.`,
    showRefresh: false,
  },
  'stepped-down': {
    title: `${APP_NAME} was opened elsewhere`,
    body: `To continue using ${APP_NAME} here, refresh this window or close the newly opened browser window.`,
    showRefresh: true,
  },
};

const DuplicateInstance = () => {
  const reason = useSelector(selectDuplicateReason);
  const copy = COPY[reason] || COPY['stepped-down'];

  useEffect(() => {
    const interval = setInterval(() => {
      sendBroadcast().catch(() => window.location.reload());
    }, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Fade in>
        <Card sx={{ maxWidth: 480, width: '100%', boxShadow: 3 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              {copy.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {copy.body}
            </Typography>
            {copy.showRefresh && (
              <Button variant="contained" onClick={handleRefresh}>
                Refresh
              </Button>
            )}
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default DuplicateInstance;
